const URL = `${window.location.protocol === "https:" ? "wss" : "ws"}://${
  window.location.host
}/ws/discussions/`;

const sockets = {};

export function openDiscussionWebsocket(conversationId, { onMessage, onClose, onError }) {
  if (sockets[conversationId]?.readyState === WebSocket.OPEN) {
    return Promise.resolve(true);
  }
  closeDiscussionWebsocket(conversationId);

  return new Promise(resolve => {
    let settled = false;
    const socket = new WebSocket(`${URL}${conversationId}/`);
    sockets[conversationId] = socket;

    socket.onopen = () => {
      settled = true;
      resolve(true);
    };
    socket.onmessage = event => {
      try {
        onMessage(JSON.parse(event.data));
      } catch (error) {
        console.error(error);
      }
    };
    socket.onerror = event => {
      if (!settled) {
        settled = true;
        resolve(false);
      }
      if (onError) {
        onError(event);
      }
    };
    socket.onclose = event => {
      if (!settled) {
        settled = true;
        resolve(false);
      }
      delete sockets[conversationId];
      if (onClose) {
        onClose(event);
      }
    };
  });
}

export function closeDiscussionWebsocket(conversationId) {
  const socket = sockets[conversationId];
  if (!socket) {
    return;
  }
  socket.onclose = null;
  socket.onerror = null;
  socket.close();
  delete sockets[conversationId];
}
